import { Injectable } from '@angular/core';
import { Firestore, addDoc, collection, collectionData, doc, docData, query, updateDoc, where } from '@angular/fire/firestore';
import { Observable, combineLatest, map, switchMap } from 'rxjs';
import { Tenant } from '../models/tenant.model';

@Injectable({
  providedIn: 'root'
})
@Injectable({ providedIn: 'root' })
export class TenantService {
  constructor(private firestore: Firestore) {}
getTenants(): Observable<Tenant[]> {
  return collectionData(
    collection(this.firestore, 'tenants'),
    { idField: 'id' }
  ) as Observable<Tenant[]>;
}
  getActiveTenants(): Observable<Tenant[]> {
    return collectionData(
      query(
        collection(this.firestore, 'tenants'),
        where('status', '==', 'active')
      ),
      { idField: 'id' }
    ) as Observable<Tenant[]>;
  }
linkUser(tenantId: string, userId: string) {
  return updateDoc(doc(this.firestore, 'tenants', tenantId), {
    userId
  });
}
  createTenant(data: Omit<Tenant, 'id' | 'createdAt' | 'status'>) {
    return addDoc(collection(this.firestore, 'tenants'), {
      ...data,
      status: 'active',
      createdAt: new Date()
    });
  }

  updateTenant(id: string, data: Partial<Tenant>) {
    return updateDoc(doc(this.firestore, 'tenants', id), data);
  }

  archiveTenant(id: string) {
    return updateDoc(doc(this.firestore, 'tenants', id), {
      status: 'archived',
      archivedAt: new Date()
    });
  }
}

